module.exports = __webpack_public_path__ + "media/images/netcredit-logo-vector-no-subtext-f37eeba6.svg";